import classNames from "classnames";
import React, { FunctionComponent, memo } from "react";

import {
  ISectionProps as IEworkitSectionProps,
  Section as EworkitSection,
  TStyleBackground,
} from "@/eworkitComponents";
import { buildBackgroundColorVariantClassNames, TColorVariant } from "@/style/colorVariants";

import "./_section.scss";

export interface ISectionProps extends Omit<IEworkitSectionProps, "background"> {
  background?: TColorVariant;
  shadow?: "none" | "default" | "highlighted";
}

export const Section: FunctionComponent<ISectionProps> = memo(props => {
  const backgroundVariant = props.background || "background-card";
  const eworkitBackground = backgroundVariant as TStyleBackground;

  const baseClassName = "section";

  return (
    <EworkitSection
      {...props}
      className={classNames(
        props.className,
        `${baseClassName}--section-shadow-${props.shadow || "default"}`,
        buildBackgroundColorVariantClassNames(backgroundVariant),
      )}
      background={eworkitBackground}
    />
  );
});
